import React from 'react'
import PanelHead from '../../UI/Panel/PanelHead';
import PanelBody from '../../UI/Panel/PanelBody';
import {OrderRequestsTable} from "../../UI/OrderRequests/OrderRequestsTable";

const OrderRequests = () => {
  return (
    <div>
      <PanelHead title="Order Requests" />
      <PanelBody content={<OrderRequestsTable />} />
    </div>
  )
}

export default OrderRequests;